<template>
  <v-app-bar
    color="#fff"
    height="70"
    fixed
    class="header pa-0"
  >
    <div class="d-flex align-center">
      <h1 class="header__logo"><router-link to="/"><strong>ImmanuelSeoul</strong> Admin</router-link></h1>
    </div>
    <v-btn rounded depressed color="grey darken-4" dark @click="onLogout">로그아웃</v-btn>
  </v-app-bar>
</template>

<script>
import principal from '@/utils/principal'
export default {
  methods: {
    onLogout () {
      principal.removePrincipal()
      this.$router.push('/admin/login')
    }
  },
  created () {
    if (document.querySelector("[name='viewport']")) {
      document.querySelector("[name='viewport']").remove()
    }
  }
}
</script>
<style lang="scss">
  .header {
    flex: 0 auto;
    &.v-app-bar.v-app-bar--fixed {
      z-index: 11;
    }
    .v-toolbar__content {
      padding: 0 20px 0 0;
      justify-content: space-between;
    }

    &.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .02);
    }

    .header__logo {
      background: rgb(41, 49, 64);
      padding: 12px 19px 20px 17px;
      max-width: 256px;
      line-height: 1;
      letter-spacing: -0.5px;
      height: 70px;
      width: 256px;
      border-bottom: 1px solid #1f2531;
      a {
        text-decoration: none;
        font-size: 1.2rem;
        color: #ffffff;
        font-weight: 500;
      }

      strong {
        color: #51c2ee;
        font-weight: 500;
      }
    }
  }
</style>
